import { Select } from 'antd';
import React from 'react';
import { GlobeIcon, LoaderIcon } from 'shared/ui/icons';
import { useLanguagePreference } from 'shared/hooks/useLanguagePreference';

export const ToggleTranslateButton = ({
  className = '',
  refetch = () => {},
  variant = 'outlined',
  localParamLanguage = null,
  setLocalParamLanguage = () => {},
}) => {
  const {
    currentLanguage: hookLanguage,
    isChanging,
    changeLanguage,
    languageOptions,
  } = useLanguagePreference();

  const handleLanguageChange = (lang) => {
    changeLanguage(lang, {
      onSuccess: () => {
        setLocalParamLanguage?.(lang);
        refetch?.(lang);
      },
    });
  };

  const activeLanguage = localParamLanguage || hookLanguage;

  const currentLanguageOption = languageOptions.find(
    (lang) => lang.value === activeLanguage
  );

  return (
    <Select
      variant={variant}
      size="large"
      className={`md:!w-48 !w-24 !h-12 ${className}`}
      disabled={isChanging}
      value={activeLanguage}
      onChange={handleLanguageChange}
      labelRender={() => (
        <div className="flex items-center gap-2">
          {isChanging ? (
            <>
              <LoaderIcon className="animate-spin w-4 h-4" />
              <span className="text-sm">Translating...</span>
            </>
          ) : (
            <>
              <GlobeIcon className="w-4 h-4" />
              <span className="text-sm font-medium md:block hidden">
                {currentLanguageOption?.label}
              </span>
              <span className="text-sm font-medium block md:hidden">
                {activeLanguage?.toUpperCase()}
              </span>
            </>
          )}
        </div>
      )}
      options={languageOptions}
      optionRender={(option) => (
        <div className="flex items-center justify-between gap-2 py-1 w-full">
          <span className="text-sm font-medium">{option.data.label}</span>
          {activeLanguage === option.value && (
            <span className="text-blue-600 font-bold">✓</span>
          )}
        </div>
      )}
    />
  );
};
